<template>
<div>
  <login />
</div>
</template>

<script>
  import Login from '../components/Login'

  export default {
    name: 'Home',
  props:["template"],
    components: {
      Login,
    },
  }
</script>
